import { render, staticRenderFns } from "./StStatement.vue?vue&type=template&id=db28a174"
import script from "./StStatement.vue?vue&type=script&lang=ts"
export * from "./StStatement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports